import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "people-picker" }
const _hoisted_2 = { class: "people-picker-multiselect-single-label multiselect-single-label" }
const _hoisted_3 = { class: "people-picker-option__persona-content" }
const _hoisted_4 = { class: "people-picker-option__persona-wrapper" }
const _hoisted_5 = { class: "people-picker-option__persona-details" }
const _hoisted_6 = { class: "people-picker-option__persona-details-primary-text" }
const _hoisted_7 = { class: "multiselect-multiple-label" }
const _hoisted_8 = { class: "people-picker-tag" }
const _hoisted_9 = { class: "people-picker-tag__content" }
const _hoisted_10 = { class: "people-picker-tag__persona" }
const _hoisted_11 = { class: "people-picker-tag__persona-details" }
const _hoisted_12 = { class: "people-picker-tag__persona-details-primary-text" }
const _hoisted_13 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Description = _resolveComponent("Description")!
  const _component_FieldError = _resolveComponent("FieldError")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(_component_Label, {
          key: 0,
          for: _ctx.computedId,
          disabled: _ctx.disabled,
          required: _ctx.required,
          size: "sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }, 8, ["for", "disabled", "required"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Multiselect, {
      ref: "multiselectRef",
      id: _ctx.computedId,
      modelValue: _ctx.modelValue,
      onChange: _ctx.onChange,
      searchable: true,
      options: _ctx.getOptions,
      filterResults: _ctx.routeName ? false : true,
      disabled: _ctx.disabled,
      minChars: 0,
      delay: 300,
      label: "label",
      valueProp: _ctx.valueProp,
      trackBy: "label",
      mode: _ctx.mode,
      noResultsText: "Ingen treff",
      noOptionsText: "Skriv inn for å søke",
      resolveOnLoad: true,
      closeOnSelect: _ctx.mode === 'single' ? true : false,
      placeholder: _ctx.placeholder,
      canClear: false,
      hideSelected: false,
      classes: {
        container: {
          'people-picker__multiselect multiselect': true,
          [`people-picker__multiselect--size-${_ctx.size}`]: _ctx.size,
        },
        containerDisabled: 'people-picker__multiselect--disabled is-disabled',
        containerOpen: 'people-picker__multiselect--open is-open',
        containerOpenTop: 'people-picker__multiselect--open-top is-open-top',
        containerActive: 'people-picker__multiselect--active is-active',
        search: 'select-resource-picker__multiselect-search multiselect-search',
        tags: {
          'people-picker__multiselect-tags multiselect-tags': true,
          [`people-picker__multiselect-tags--size-${_ctx.size}`]: _ctx.size,
        },
        tagsSearchWrapper:
          'people-picker__multiselect-tags-search-wrapper multiselect-tags-search-wrapper',
        tagsSearch:
          'people-picker__multiselect-tags-search multiselect-tags-search',
        options: 'people-picker__multiselect-options multiselect-options',
        optionsTop: 'people-picker__multiselect-options--is-top is-top',
        option: 'people-picker-option multiselect-option',
        optionPointed: 'people-picker-option--is-pointed is-pointed',
        optionSelected: 'people-picker-option--is-selected is-selected',
        optionDisabled: 'people-picker-option--is-disabled is-disabled',
        optionSelectedPointed:
          'people-picker-option--is-pointed is-pointed people-picker-option--is-selected is-selected',
        optionSelectedDisabled:
          'people-picker-option--is-selected is-selected people-picker-option--is-disabled is-disabled',
        placeholder:
          'people-picker__multiselect-placeholder multiselect-placeholder',
        caret: 'people-picker__multiselect-caret multiselect-caret',
        caretOpen: 'people-picker__multiselect-caret--open is-open',
        clear: 'people-picker__clear multiselect-clear',
        clearIcon: 'people-picker__clear-icon multiselect-clear-icon',
        spinner: 'people-picker__multiselect-spinner multiselect-spinner',
        noOptions: {
          'people-picker__multiselect-no-options multiselect-no-options': true,
          [`people-picker__multiselect-no-options--size-${_ctx.size}`]: _ctx.size,
        },
        noResults: {
          'people-picker__multiselect-no-results multiselect-no-results': true,
          [`people-picker__multiselect-no-results--size-${_ctx.size}`]: _ctx.size,
        },
      },
      onClose: _ctx.addFirstFromSearch
    }, {
      singlelabel: _withCtx(({ value }) => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(value.label), 1)
      ]),
      option: _withCtx(({ option }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(option.label), 1)
            ])
          ])
        ])
      ]),
      multiplelabel: _withCtx(({ values }) => [
        _createElementVNode("div", _hoisted_7, _toDisplayString(values.length) + " selected ", 1)
      ]),
      tag: _withCtx(({ option, handleTagRemove, disabled }) => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(option.label), 1)
              ])
            ])
          ]),
          (!disabled)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "people-picker-tag__remove-button",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                onMousedown: _withModifiers(($event: any) => (handleTagRemove(option, $event)), ["prevent","stop"])
              }, null, 40, _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["id", "modelValue", "onChange", "options", "filterResults", "disabled", "valueProp", "mode", "closeOnSelect", "placeholder", "classes", "onClose"]),
    (Boolean(_ctx.description))
      ? (_openBlock(), _createBlock(_component_Description, {
          key: 1,
          class: "people-picker__description"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.description), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_FieldError, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"]),
    _createVNode(_component_FieldError, { errorMessage: _ctx.apiErrorMessage }, null, 8, ["errorMessage"])
  ]))
}